module.exports = {
    API_BASE_URL: 'https://flownowplextech.onrender.com',
    DEBUG_TIME: null
  };

//default: 'https://flownowplextech.onrender.com'
//local: 'http://localhost:5001'
//Switch backend/backend.js accordingly as well.

// export const DEBUG_TIME = null;
// default: null
// debug: 5
